import { render } from "./App.vue?vue&type=template&id=678d93b6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=678d93b6&lang=scss"

import exportComponent from "E:\\work9\\wzbz_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__